<div class="bg-grid">
  <mat-card class="card-content">
    <mat-card-content class="about-us-card">
      <div class="main-logo">
        <img src="assets/images/eZintegration-black-logo.svg">
      </div>
      <div class="release-data">
        <p>eZintegrations Release Version: {{releaseVersion}}</p>
        <p>eZintegrations Release Date: {{releaseDate}}</p>
      </div>
      <div class="company-logo">
        <p>Powered by</p>
        <img src="assets/images/bizdata-header-logo.svg">
      </div>
    </mat-card-content>
    <mat-icon class="close-button" (click)="closeModal()">cancel</mat-icon>
  </mat-card>
</div>